<script setup lang="ts">
  import { MpCard, MpMenu, MpText } from '@borg/ui';

  const items = [
    {
      name: 'calculator-salary',
      labelKey: 'CALCULATORS_NAVIGATION.SALARY_CALCULATOR_LINK_LABEL',
    },
    {
      name: 'calculator-author',
      labelKey: 'CALCULATORS_NAVIGATION.AUTHOR_CALCULATOR_LINK_LABEL',
    },
    {
      name: 'calculator-service',
      labelKey: 'CALCULATORS_NAVIGATION.SERVICE_CALCULATOR_LINK_LABEL',
    },
  ];
</script>

<template>
  <MpCard
    p="xs unset"
    corners="round-md"
    border
  >
    <MpMenu :title="$t('CALCULATORS_NAVIGATION.NAVIGATOR_TITLE')">
      <LinksLocale
        v-for="item in items"
        :key="item.labelKey"
        :to="{ name: item.name }"
      >
        <MpText
          type="body1"
          no-margin
        >
          {{ $t(item.labelKey) }}
        </MpText>
      </LinksLocale>
    </MpMenu>
  </MpCard>
</template>
